import {
  Bell,
  CalendarCheck,
  FileText,
  IndianRupee,
  ListTodo,
  Mail,
  Mic,
  NotebookPen,
  Phone,
  PhoneCall,
  Plus,
  Receipt,
  UserPlus,
} from 'lucide-react'
import type { TimelineActivityType } from './types'

interface ActivityMeta {
  icon: typeof Phone
  /** Tailwind classes for the round marker on the timeline. */
  tone: string
  label: string
}

const META: Record<TimelineActivityType, ActivityMeta> = {
  lead_created: { icon: Plus, tone: 'bg-blue-600 text-white', label: 'Lead created' },
  lead_assigned: { icon: UserPlus, tone: 'bg-emerald-600 text-white', label: 'Lead assigned' },
  conversion: { icon: UserPlus, tone: 'bg-indigo-600 text-white', label: 'Converted' },
  deal_created: { icon: Plus, tone: 'bg-blue-600 text-white', label: 'Deal created' },
  call: { icon: PhoneCall, tone: 'bg-blue-600 text-white', label: 'Call' },
  followup: { icon: Bell, tone: 'bg-amber-500 text-white', label: 'Follow-up' },
  call_history: { icon: Mail, tone: 'bg-purple-600 text-white', label: 'Call history' },
  meeting: { icon: CalendarCheck, tone: 'bg-sky-600 text-white', label: 'Meeting' },
  recording: { icon: Mic, tone: 'bg-rose-600 text-white', label: 'Recording' },
  note: { icon: NotebookPen, tone: 'bg-teal-600 text-white', label: 'Note' },
  todo: { icon: ListTodo, tone: 'bg-violet-600 text-white', label: 'Task' },
  reminder: { icon: Bell, tone: 'bg-amber-500 text-white', label: 'Reminder' },
  quotation: { icon: FileText, tone: 'bg-purple-600 text-white', label: 'Quotation' },
  proforma: { icon: Receipt, tone: 'bg-fuchsia-600 text-white', label: 'Proforma' },
  invoice: { icon: Receipt, tone: 'bg-cyan-700 text-white', label: 'Tax invoice' },
  payment: { icon: IndianRupee, tone: 'bg-green-600 text-white', label: 'Payment' },
}

export function activityMeta(type: TimelineActivityType): ActivityMeta {
  return META[type] ?? META.note
}

export const ACTIVITY_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'all', label: 'All Activities' },
  { value: 'call', label: 'Calls' },
  { value: 'followup', label: 'Follow-ups' },
  { value: 'meeting', label: 'Meetings' },
  { value: 'call_history', label: 'Call history' },
  { value: 'note', label: 'Notes' },
  { value: 'recording', label: 'Recordings' },
  { value: 'quotation', label: 'Quotations' },
  { value: 'proforma', label: 'Proforma invoices' },
  { value: 'invoice', label: 'Tax invoices' },
  { value: 'payment', label: 'Payments' },
]
